import React, { useState, forwardRef, useImperativeHandle } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import SelectOption from '../select/select-option';
import Api from '../../api/global.service';

const ModalCuentasBajas = forwardRef((props, ref) => {
  ModalCuentasBajas.displayName = 'ModalCuentasBajas';
  const padrones = ['confirmado', 'organico'];
  const [show, setShow] = useState(false);
  const [blocking, setBlocking] = useState(false);
  const [razonBaja, setRazonBaja] = useState(null);
  const [catCuentasBaja, setCatCuentasBaja] = useState([]);

  //To call outside
  useImperativeHandle(ref, () => ({
    open: openHandler,
    close: closeHandler,
  }));

  const getCatalogs = async () => {
    setBlocking(true);
    const response = await Api.getAll('sic/cat_cuentas_bajas');
    if (response.status === 200) {
      const bajas = [];
      response.data.forEach(baja => {
        bajas.push({ label: baja.nombre, value: baja.id });
      });
      setCatCuentasBaja(bajas);
    }
    setBlocking(false);
  };

  const openHandler = () => {
    setShow(true);
    getCatalogs();
  };

  const closeHandler = () => {
    setShow(false);
  };

  const validateHandler = () => {
    const data = {
      padronesSeleccionados: padrones,
      id_cat_cuentas_bajas: razonBaja,
    };
    razonBaja !== null && props.onConfirm(data);
  };

  return (
    <div className="modal" style={{ display: show ? 'block' : 'none', backgroundColor: 'rgba(0,0,0,0.2)' }}>
      <div className="modal-dialog" style={{ top: 50, right: 25, position: 'absolute', width: 400, height: 'calc(100% - 100px)' }}>
        <div className="modal-content" style={{ height: '100%' }}>
          <div className="modal-header" style={{ flex: 'inherit' }}>
            <h4 className="modal-title">{props.title}</h4>
            <button onClick={() => closeHandler()} type="button" className="btn" style={{ borderRadius: '20px' }}>
              <i className="fa fa-times"></i>
            </button>
          </div>
          <div className="modal-body">
            <h5>¿Cuál es el motivo de la baja?</h5>
            <SelectOption
              data={catCuentasBaja}
              setFilter={event => setRazonBaja(event.value)}
              style={{ width: '100%' }}
              className="mb-4"></SelectOption>
            {blocking && (
              <div className="spinner-border text-warning" role="status">
                <span className="sr-only">Dando de baja...</span>
              </div>
            )}
            {!blocking && (
              <>
                <button disabled={razonBaja === null} onClick={() => validateHandler()} type="button" className="btn btn-block btn-danger">
                  Dar de baja
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default ModalCuentasBajas;
